import { Reducer } from "redux";

import { ReAuthDefaultReferralDataActionDispatchTypes } from "../models/dispatchTypes/Referral";
import { ReAuthDefaultReferralDataDispatchTypes } from "../constants/Referral";
import { ReAuthDefaultReferralDataResponse } from "../models/api/Referral";

const initialState: ReAuthDefaultReferralDataResponse = {
  loading: false,
  response: {
    patientFirstName: "",
    patientLastName: "",
    patientDOB: "",
    patientPostalCode: "",
    patientRegion: "",
    patientCounty: "",
    patientCountry: "",
    patientStreet: "",
    patientCity: "",
    physicianName: "",
    physicianPhone: "",
    physicianNPI: "",
    physicianId: 0,
    referralId: 0,
    startOfCare: "",
    patientEligibilityId: 0,
    subscriberId: "",
    eligibilityPayerId: "",
    eligibilityPayerName: "",
    patientId: 0,
    startOfCareVerified: true,
    sendApprovedAuthTo: "",
    bcbsTnSOCRetroTrue: false,
    authorizationNumber: ""
  },
  error: null,
};

const ReAuthReferralDataReducer: Reducer<
  ReAuthDefaultReferralDataResponse,
  ReAuthDefaultReferralDataActionDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case ReAuthDefaultReferralDataDispatchTypes.RE_AUTH_DEFAULT_REFERRAL_DATA_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case ReAuthDefaultReferralDataDispatchTypes.RE_AUTH_DEFAULT_REFERRAL_DATA_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case ReAuthDefaultReferralDataDispatchTypes.RE_AUTH_DEFAULT_REFERRAL_DATA_ERRORS: {
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    }
    case ReAuthDefaultReferralDataDispatchTypes.RE_AUTH_DEFAULT_REFERRAL_DATA_RESET: {
      return initialState;
    }
  }
  return state;
};

export default ReAuthReferralDataReducer;
